/* eslint-disable */
import Mail from '@/components/global-all-user-mail/index.vue';
import Message from '@/components/global-all-user-message/index.vue';
var $ = window.jQuery = require('jquery');
export default {
  name: 'global-message-user',
  components: {
    'mail-device' : Mail,
    'message-device' : Message
  },
  props: [],
  data () {
    return {
      selection_type:'Mail'
    }
  },
  methods: {
    selectedOptionMethod(item){
      this.selection_type = item
    }
  },
  watch:{
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    next();
  }
}